
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { flagUrl, countryName } from "./countries";

export default defineComponent({
  name: "GroupProfile",
  props: {
    id: { type: [String, Number], required: true },
  },
  setup(props) {
    const loading = ref(true);
    const group = ref<any>(null);

    onMounted(async () => {
      try {
        const { data } = await ApiService.get(`groups/${props.id}`);
        group.value = data;
      } catch {
        group.value = null;
      } finally {
        loading.value = false;
      }
    });

    return { loading, group, flagUrl, countryName };
  },
});
